<!-- 入力エラーメッセージ表示フィールド -->
<template>
  <div v-if="normalizedLines.length" class="error-message">
    <span>
      <img src="../../assets/images/icon/icon_error.svg" alt="" />
      <template v-for="(line, i) in normalizedLines" :key="i">
        {{ line }}
        <br v-if="i < normalizedLines.length - 1" />
      </template>
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useFieldError } from 'vee-validate'

const props = defineProps<{
  name?: string
  message?: string
}>()

const fieldError = props.name ? useFieldError(props.name) : null
const msg = computed(() => props.message ?? (fieldError ? fieldError.value : '') ?? '')

const normalizedLines = computed(() =>
  Array.isArray(msg.value) ? msg.value : msg.value ? msg.value.split('\n') : [],
)
</script>
